module.exports = __webpack_public_path__ + "img/144.012155a7.jpg";